"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Handler_1 = __importDefault(require("./Handler"));
var constant_1 = require("../constant");
var utils_1 = require("../utils");
var JDImager = (function (_super) {
    __extends(JDImager, _super);
    function JDImager(src, props) {
        var _this = _super.call(this, src, props) || this;
        _this.name = "jd";
        _this.imageProps = props;
        _this.keepSize = props.keepSize || false;
        _this.originSrc = src;
        return _this;
    }
    JDImager.prototype.transferJDIamgeURL = function (imageUrl, imageProps, keepSize) {
        var imageSrc = imageUrl, spec = "";
        var _a = (imageProps || {}).qnParams, qnParams = _a === void 0 ? {} : _a;
        qnParams = __assign({}, qnParams);
        if (utils_1.isSupportWebP()) {
            imageSrc = imageSrc.replace(/(\.jpg$)/, function (match) {
                return match + "!q80.webp";
            });
            imageSrc = imageSrc.replace(/\.dpg$/, ".webp");
        }
        if (typeof qnParams === "object") {
            if (qnParams.w || qnParams.h) {
                if (keepSize === true) {
                    qnParams.w = utils_1.transferTens(qnParams.w || qnParams.h);
                    qnParams.h = utils_1.transferTens(qnParams.h || qnParams.w);
                }
                else {
                    var cw = (qnParams.w || qnParams.h) || 0;
                    var ch = (qnParams.h || qnParams.w) || 0;
                    qnParams.w = utils_1.transferTens(cw * constant_1.DevicePixelRatio);
                    qnParams.h = utils_1.transferTens(ch * constant_1.DevicePixelRatio);
                }
                spec = qnParams.w + "x" + qnParams.h;
                imageSrc = imageSrc.replace(/(\/mobilecms\/s)\d+x\d+/, function (match, pref) {
                    return pref + spec;
                });
            }
        }
        return imageSrc;
    };
    JDImager.prototype.getCompatibleImageUrl = function () {
        var src = this.compatibleImageUrl;
        return this.transferJDIamgeURL(src, this.imageProps, this.keepSize);
    };
    JDImager.prototype.makeImageUrls = function () {
        var sourceWithWebpAndSize, sourceWithJpgAndSize, sourceWithWebp, sourceWithJpg;
        var src = this.getCompatibleImageUrl();
        if (src.endsWith(".webp")) {
            sourceWithWebpAndSize = src;
            sourceWithWebp = src.replace(/(\/mobilecms\/)s\d+x\d+([^\/]+)/, "$1$2");
        }
        sourceWithJpgAndSize = src.replace(/\.jpg(!q\d+)?\.\D*$/, ".jpg");
        sourceWithJpg = sourceWithJpgAndSize.replace(/(\/mobilecms\/)s\d+x\d+([^\/]+)/, "$1$2");
        return utils_1.dropEmptyValue([
            sourceWithWebpAndSize,
            sourceWithWebp,
            sourceWithJpgAndSize,
            sourceWithJpg,
            this.originSrc === sourceWithJpg ? "" : this.originSrc,
        ]);
    };
    JDImager.match = function (src) {
        return /\.360buyimg\.com/.test(src);
    };
    return JDImager;
}(Handler_1.default));
exports.default = JDImager;
